






























import { Icon } from '@alpha/ink'
import { Stage } from './AddTestModal.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Icon
  }
})
export default class StageNav extends Vue {
  @Prop({ required: true }) readonly stage!: Stage

  get Stage () {
    return Stage
  }
}
